import type { ModuleTagEntry } from './index';

/** General Image module tags. */
export const tags: ModuleTagEntry[] = [
  'SOPInstanceUID',
  'SOPClassUID',
  'InstanceNumber',
  'InstanceCreationDate',
  'InstanceCreationTime',
  'ContentTime',
  'LossyImageCompression',
  'LossyImageCompressionRatio',
  'LossyImageCompressionMethod',
  'FrameOfReferenceUID',
  'NumberOfFrames',
  'PixelSpacing',
];
